import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonChecks } from '../../core/utilities/common-checks.utilities';
import { FormValidatorMessages } from '../../core/enums/forms.enums';
import { BaseInputComponentClass } from '../../core/base-classes/base-input-component-class';

@Component({
  selector: 'ms-email-input',
  standalone: true,
  imports: [],
  templateUrl: './email-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailInput),
      multi: true
    }
  ]
})
export class EmailInput extends BaseInputComponentClass implements ControlValueAccessor {

  //#region Properties

  public value = '';

  //#endregion Properties

  //#region ControlValueAccessor

  public writeValue(value: string): void {
    this.value = value || '';
  }

  //#endregion ControlValueAccessor

  //#region State Getters

  public get isValid(): boolean {
    return this.touched
      && !CommonChecks.isNullOrUndefinedOrEmpty(this.value)
      && this.ngControl?.control?.errors == null;
  }

  //#endregion State Getters

  //#region Event Handlers

  public onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
  }

  //#endregion Event Handlers

  //#region Validation

  public getErrors(): string[] {
    const errors: string[] = [];
    const controlErrors = this.ngControl?.control?.errors;

    if (controlErrors) {
      if (controlErrors['required']) {
        errors.push(controlErrors['required'].message || FormValidatorMessages.EmailRequired);
      }
      if (controlErrors['email']) {
        errors.push(controlErrors['email'].message || FormValidatorMessages.EmailInvalid);
      }
    }

    return errors;
  }

  //#endregion Validation
}
